(() => {
  'use strict';
  if (!['trynolvia.co', 'www.trynolvia.co'].includes(location.hostname)) return;

  const catalogNode = document.getElementById('hmh-local-bag-catalog');
  const brandNode = document.getElementById('hmh-brand-config');
  const lineTemplate = document.getElementById('hmh-local-bag-line');
  const summaryTemplate = document.getElementById('hmh-local-bag-summary');
  if (!(catalogNode && brandNode && lineTemplate && summaryTemplate)) return;

  const catalog = new Map();
  try {
    const allowed = new Set(JSON.parse(brandNode.textContent).variantIds);
    const livePrices = JSON.parse(document.getElementById('hmh-local-bag-prices')?.textContent || '{}');
    for (const item of JSON.parse(catalogNode.textContent)) {
      if (!allowed.has(item.id) || !/^\d{10,16}$/.test(item.id) || !/^[a-z0-9-]+$/.test(item.handle)) return;
      const image = new URL(item.image);
      if (image.origin !== 'https://cdn.shopify.com' || !image.pathname.startsWith('/s/files/1/0786/7311/7258/files/')) return;
      const cents = livePrices[item.id] ?? item.cents;
      if (!Number.isSafeInteger(cents) || cents < 1 || cents > 1000000) return;
      catalog.set(item.id, { ...item, cents });
    }
    if (catalog.size !== 40 || allowed.size !== catalog.size) return;
  } catch { return; }

  const key = 'hmh:78673117258:local-mug-bag:v1';
  const maxQuantity = 999;
  const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const money = cents => usd.format(cents / 100);
  const storageError = 'This browser could not save your cart. Please enable browser storage and reload.';
  const mounts = () => Array.from(document.querySelectorAll('[data-hmh-local-surface] [data-hmh-local-lines]'));
  let storageAvailable = true;
  let quantities = {};
  let previousCount = 0;
  const reviewPage = document.querySelector('[data-hmh-order-review]');
  const cartEditor = document.querySelector('[data-hmh-cart-editor]');
  const cartContext = new URLSearchParams(location.search);

  function preserveShoppingContext(anchor) {
    if (!anchor) return;
    const url = new URL(anchor.href, location.href);
    for (const [key, value] of cartContext) {
      if (/^(?:country|currency|locale|utm_(?:source|medium|campaign|content|term|id))$/.test(key)) {
        url.searchParams.set(key, value);
      }
    }
    anchor.href = url.href;
  }

  function read() {
    const stored = JSON.parse(localStorage.getItem(key) || '{}');
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) throw new Error(storageError);
    for (const [id, qty] of Object.entries(stored)) {
      if (!catalog.has(id) || !Number.isSafeInteger(qty) || qty < 1 || qty > maxQuantity) throw new Error(storageError);
    }
    return stored;
  }

  function message(scope, selector, text) {
    const area = scope?.querySelector(selector);
    if (!area) return;
    area.textContent = text;
    area.hidden = !text;
  }

  function configureButtons(scope = document) {
    for (const button of scope.querySelectorAll('[data-hmh-local-add]')) {
      const form = button.form;
      const item = catalog.get(form?.elements.namedItem('id')?.value);
      const eligible = Boolean(form?.closest('[data-hmh-local-product]') && item && item.cents === Number(button.dataset.hmhLocalCents));
      button.disabled = !storageAvailable || !eligible;
      if (!storageAvailable) message(form, '[data-product-error]', storageError);
    }
  }

  function line(item, qty, reviewOnly = false) {
    const el = lineTemplate.content.firstElementChild.cloneNode(true);
    el.dataset.bagId = item.id;
    for (const link of el.querySelectorAll('a')) link.href = '/products/' + item.handle;
    const image = el.querySelector('img');
    image.src = item.image;
    image.alt = item.alt || item.title;
    el.querySelector('.hmh-line__name').textContent = item.title;
    el.querySelector('.hmh-line__unit').textContent = money(item.cents) + ' each';
    el.querySelector('.hmh-line__total').textContent = money(item.cents * qty);
    if (reviewOnly) {
      el.querySelector('.hmh-line__controls').remove();
      el.querySelector('.hmh-line__unit').textContent = qty + ' × ' + money(item.cents) + ' each';
      return el;
    }
    const input = el.querySelector('[data-bag-quantity]');
    input.value = qty;
    input.setAttribute('aria-label', 'Quantity for ' + item.title);
    for (const [action, label] of [['less', 'Decrease quantity for '], ['more', 'Increase quantity for '], ['remove', 'Remove ']]) {
      const button = el.querySelector('[data-bag-action="' + action + '"]');
      button.setAttribute('aria-label', label + item.title);
      button.disabled = !storageAvailable || (action === 'more' && qty >= maxQuantity);
    }
    return el;
  }

  function showReview(entries, subtotal, nativeCount) {
    if (!reviewPage || !cartEditor) return;
    const active = location.hash === '#order-review' && nativeCount === 0 && entries.length > 0;
    const entering = active && reviewPage.hidden;
    cartEditor.hidden = active;
    reviewPage.hidden = !active;
    if (!active) return;
    const available = storageAvailable && nativeCount === 0;
    const filled = available && entries.length > 0;
    const empty = reviewPage.querySelector('[data-review-empty]');
    reviewPage.querySelector('[data-review-filled]').hidden = !filled;
    empty.hidden = filled;
    if (!storageAvailable) empty.textContent = storageError;
    else if (nativeCount !== 0) empty.textContent = 'Return to your cart to review all items.';
    else empty.textContent = 'Your cart is empty.';
    const lines = reviewPage.querySelector('[data-review-lines]');
    lines.replaceChildren(...(filled ? entries.map(([id, qty]) => line(catalog.get(id), qty, true)) : []));
    reviewPage.querySelector('[data-review-subtotal]').textContent = filled ? money(subtotal) + ' USD' : '';
    preserveShoppingContext(reviewPage.querySelector('[data-review-edit]'));
    if (entering) reviewPage.querySelector('h1').focus();
  }

  function render() {
    const entries = Object.entries(quantities);
    const count = entries.reduce((total, [, qty]) => total + qty, 0);
    const subtotal = entries.reduce((total, [id, qty]) => total + catalog.get(id).cents * qty, 0);
    const nativeCount = Number(document.querySelector('[data-cart-count-value]')?.dataset.cartCountValue || 0);
    if (previousCount > 0 && count === 0) document.dispatchEvent(new Event('hmh:local-bag-emptied'));
    previousCount = count;
    showReview(entries, subtotal, nativeCount);
    for (const mount of mounts()) {
      const surface = mount.closest('[data-hmh-local-surface]');
      surface.toggleAttribute('data-hmh-local-active', count > 0);
      const next = document.createDocumentFragment();
      if (count) {
        const lines = document.createElement('ul');
        lines.className = 'hmh-cart__lines';
        for (const [id, qty] of entries) lines.append(line(catalog.get(id), qty));
        const summary = summaryTemplate.content.firstElementChild.cloneNode(true);
        summary.querySelector('[data-bag-subtotal]').textContent = money(subtotal) + ' USD';
        const reviewLink = summary.querySelector('[data-hmh-review-link]');
        preserveShoppingContext(reviewLink);
        const total = summary.querySelector('[data-saved-estimate]');
        if (total && nativeCount === 0) total.textContent = money(subtotal + 495) + ' USD';
        if (nativeCount > 0) summary.querySelector('[data-saved-shipping]')?.remove();
        preserveShoppingContext(summary.querySelector('.hmh-cart__view'));
        if (surface.dataset.hmhLocalSurface === 'page') summary.querySelector('.hmh-cart__view')?.remove();
        next.append(lines, summary);
      }
      if (!storageAvailable) {
        const alert = document.createElement('p');
        alert.className = 'hmh-cart__error';
        alert.setAttribute('role', 'alert');
        alert.textContent = storageError;
        next.append(alert);
      }
      mount.replaceChildren(next);
    }
    const combined = count + (Number.isSafeInteger(nativeCount) ? nativeCount : 0);
    for (const badge of document.querySelectorAll('[data-cart-count]')) {
      badge.textContent = String(combined);
      badge.hidden = !combined;
    }
  }

  function failClosed() {
    storageAvailable = false;
    quantities = {};
    configureButtons();
    render();
  }

  function update(id, amount, increment) {
    if (!storageAvailable || !catalog.has(id)) return false;
    try {
      const latest = read();
      const qty = (increment ? latest[id] || 0 : 0) + amount;
      if (!Number.isSafeInteger(qty) || qty < 0 || qty > maxQuantity) return false;
      if (qty) latest[id] = qty;
      else delete latest[id];
      const value = JSON.stringify(latest);
      localStorage.setItem(key, value);
      if (localStorage.getItem(key) !== value) throw new Error(storageError);
      quantities = latest;
      render();
      return true;
    } catch {
      failClosed();
      return false;
    }
  }

  function add(form, button) {
    const item = catalog.get(form.elements.namedItem('id')?.value);
    const field = form.elements.namedItem('quantity');
    const qty = field?.valueAsNumber;
    if (button.disabled || !item || item.cents !== Number(button.dataset.hmhLocalCents)) return;
    if (!field.checkValidity() || !Number.isSafeInteger(qty) || qty < 1 || qty > maxQuantity) {
      message(form, '[data-product-error]', 'Enter a whole quantity between 1 and ' + maxQuantity + '.');
      return;
    }
    if (!update(item.id, qty, true)) {
      message(form, '[data-product-error]', storageAvailable ? 'The maximum is ' + maxQuantity + ' per design.' : storageError);
      return;
    }
    const text = 'Added ' + qty + ' × ' + item.title + ' to your cart.';
    message(form, '[data-product-error]', '');
    message(form, '[data-product-status]', text);
    message(document, '[data-global-status]', text);
    document.dispatchEvent(new CustomEvent('hmh:local-bag-added', { detail: { form, text } }));
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('button');
    if (!button) return;
    if (button.matches('[data-hmh-local-add]') && button.form?.closest('[data-hmh-local-product]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      add(button.form, button);
      return;
    }
    const action = button.dataset.bagAction;
    const row = button.closest('[data-hmh-local-lines] [data-bag-id]');
    if (!action || !row || !['less', 'more', 'remove'].includes(action)) return;
    event.preventDefault();
    const id = row.dataset.bagId;
    const surface = row.closest('[data-hmh-local-surface]');
    if (!update(id, action === 'more' ? 1 : action === 'less' ? -1 : 0, action !== 'remove')) return;
    const next = surface.querySelector('[data-bag-id="' + id + '"] [data-bag-action="' + action + '"]')
      || surface.querySelector('[data-bag-action], .hmh-empty a');
    next?.focus({ preventScroll: true });
    message(document, '[data-global-status]', 'Cart updated.');
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.closest('[data-hmh-local-product]')) return;
    const button = form.querySelector('[data-hmh-local-add]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(form, button);
  }, true);

  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-bag-quantity]')) return;
    const id = input.closest('[data-bag-id]')?.dataset.bagId;
    const surface = input.closest('[data-hmh-local-surface]');
    if (!catalog.has(id) || !surface) return;
    if (!input.validity.valid || !Number.isSafeInteger(input.valueAsNumber)) {
      input.value = quantities[id];
      return;
    }
    if (update(id, input.valueAsNumber, false)) {
      (surface.querySelector('[data-bag-id="' + id + '"] [data-bag-quantity]') || surface.querySelector('.hmh-empty a'))?.focus({ preventScroll: true });
      message(document, '[data-global-status]', 'Cart updated.');
    }
  });

  function reload() {
    try {
      quantities = read();
      configureButtons();
      render();
    } catch { failClosed(); }
  }
  try {
    const probe = key + ':probe';
    localStorage.setItem(probe, '1');
    if (localStorage.getItem(probe) !== '1') throw new Error(storageError);
    localStorage.removeItem(probe);
  } catch { failClosed(); return; }
  reload();
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) reload(); });
  window.addEventListener('pageshow', reload);
  if (reviewPage) window.addEventListener('hashchange', reload);
  new MutationObserver(records => {
    let refreshCart = false;
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('[data-hmh-local-product], [data-product-detail]') || node.querySelector('[data-hmh-local-product]')) configureButtons(node);
      if (node.matches('[data-cart-content]') || node.querySelector('[data-cart-content]')) refreshCart = true;
    }
    if (refreshCart) render();
  }).observe(document.body, { childList: true, subtree: true });
})();
